import { render, staticRenderFns } from "./ marketing-person-header.vue?vue&type=template&id=78de0588&scoped=true&"
import script from "./ marketing-person-header.vue?vue&type=script&lang=js&"
export * from "./ marketing-person-header.vue?vue&type=script&lang=js&"
import style0 from "./ marketing-person-header.vue?vue&type=style&index=0&id=78de0588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78de0588",
  null
  
)

export default component.exports